import { RESETERROR } from 'redux/modules/search-and-browse/actions/types';

export const resetError = () => ({
  type: RESETERROR,
});
